import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import '../src/style/index.css'
import '../src/style/global.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <BrowserRouter>
     <App />
     </BrowserRouter>
);

